import { Component } from "react";
import Button from "@material-ui/core/Button";
import { autoInvestConnector } from "../../../services/autoInvest/connector";
import { compose } from "redux";

class AutoInvestComponent extends Component {
  UNSAFE_componentWillMount = () => {
    this.props.getAutoinvestStatus();
  };

  render() {
    return (
      <div style={{ margin: "20px" }}>
        {this.props.autoinvest.fetched ? (
          <div>
            Auto invest enabled: {this.props.autoinvest.enabled.toString()}{" "}
            <br />
            <Button
              variant="contained"
              color="primary"
              onClick={this.props.switchAutoinvestStatus.bind(
                this,
                this.props.autoinvest.enabled,
              )}
            >
              Switch auto invest status
            </Button>
          </div>
        ) : undefined}
      </div>
    );
  }
}

export default compose(autoInvestConnector)(AutoInvestComponent);
